import React from 'react';
import ListViewContainer from '../shared/ListViewContainer';
import Button from 'components/elements/button';
import Box from 'components/elements/Box';
import P from 'components/elements/p';

interface IDeleteListProps {
  close: () => void;
  deleteAction: () => void;
  pending?: boolean;
}

const DeleteList: React.FC<IDeleteListProps> = (props) => {
  const { close, deleteAction, pending } = props;

  return (
    <ListViewContainer
      title="Warning"
      rejectedMessage={undefined}
      close={close}
    >
      <Box>
        <P>
          Deleting a list cannot be undone, and will delete the list for all
          other curators and followers.
        </P>

        <P>
          If you don&#39;t want to curate or follow this list you can also
          select &quot;Leave List&quot; from the Manage List dropdown.
        </P>

        <P color="NegativeChange">Are you sure you want to delete this list?</P>
      </Box>

      <Box
        mt={'2em'}
        display="flex"
        justifyContent="flex-end"
        alignItems="flex-end"
        mb={'2em'}
      >
        <Button
          onClick={close}
          variant={pending ? 'disabled' : 'secondary'}
          alignSelf="auto"
          fontWeight={600}
          disabled={pending}
        >
          Cancel
        </Button>
        <Button
          fontWeight={600}
          variant={pending ? 'disabled' : 'destructive'}
          alignSelf="auto"
          marginLeft=".5em"
          onClick={deleteAction}
          data-gtag="custom-list-delete-list"
          data-pw="custom-lists-dialog-confirmation-delete-list-btn"
        >
          Delete List
        </Button>
      </Box>
    </ListViewContainer>
  );
};

export default DeleteList;
